import React from 'react';
import ShiftsApp from '../Functionality/ShiftsApp';
import NotInformation from '../../../../../components/NotInformation';
import routes from '../../../../../Routes/routes';
import CustomExpandableTable from '../../../../../components/table/CustomExpandableTable';
import ScheduleHeader from './ScheduleHeader';
import {permissionObj} from '../../../../../Helpers/permission';
import {FoodieShiftRenderDetails} from "./FoodieShiftRenderDetails";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * Shifts component renders the shifts table with search, header, and
 * conditional modals for creating new shifts.
 *
 * It uses `ShiftsApp` to manage table data, actions, and pagination.
 *
 * @param {Array} selectForDelete - List of selected shift IDs for deletion.
 * @param {Function} setSelectForDelete - Function to update selected shift IDs.
 * @param {boolean} modified - Flag to track data modifications.
 * @param {Function} setModified - Setter used to update the `modified` flag and trigger data reloads (required).
 * @param {string} optionView - Current schedule view (shifts, meals, access codes).
 * @param {Function} handleBtnShifts - Handler to switch to shifts view.
 * @param {Function} handleBtnMeals - Handler to switch to meals view.
 * @param {Function} handleBtnAccessCode - Handler to switch to access codes view.
 *
 * @returns {JSX.Element} Rendered Shifts component.
 */
const Shifts = ({
    selectForDelete,
    setSelectForDelete,
    modified,
    setModified,
    optionView,
    handleBtnShifts,
    handleBtnMeals,
    handleBtnAccessCode,
    option
}) => {
    const {
        t,
        DEV,
        permission,
        searchId,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        rowsPerPage,
        columns,searchResults,
        renderOptionsMenu,
        handleRowExpand,
        setBodyForExport,
        setSearchResults,
        setSearchElement,
        setSimpleSearch,
        search,
        setSearch,
        searchElement,
        deletePermission
    } = ShiftsApp({
        selectForDelete,
        setSelectForDelete,
        modified,
        setModified,
        option
    });

    return (<>

        <ScheduleHeader
            optionView={optionView}
            handleBtnShifts={handleBtnShifts}
            handleBtnMeals={handleBtnMeals}
            handleBtnAccessCode={handleBtnAccessCode}
            searchId={searchId}
            setBodyForExport={setBodyForExport}
            setSearchResults={setSearchResults}
            searchElement={searchElement}
            setSearchElement={setSearchElement}
            option={option}
            rowsPerPage={rowsPerPage}
            setSimpleSearch={setSimpleSearch}
            search={search}
            setSearch={setSearch}
            DEV={DEV}
            permission={permission}
        />

            {searchResults?.content?.length > 0 ? (
                <>
                    {/**Done*/}
                    <CustomExpandableTable
                        columns={columns}
                        rows={searchResults?.content}
                        renderExpandedRow={FoodieShiftRenderDetails}
                        renderOptionsMenu={
                            DEV ||
                            permission?.includes(permissionObj?.WEB_FOODIE_SHIFT_UPDATE) ||
                            permission?.includes(permissionObj?.WEB_FOODIE_SHIFT_DELETE)
                                ? renderOptionsMenu
                                : false
                        }
                        checkbox={deletePermission}
                        onRowExpand={handleRowExpand}
                        selectedList={selectForDelete}
                        handleCheckboxChange={handleCheckboxChange}
                        handleDeleteAll={handleDeleteAll}
                        rowsPerPage={rowsPerPage}
                    />
                    {pagination()}
                </>
            ) : (
                 <NotInformation
                     className={"mt-4"}
                     card={true}
                     text={ t('you_have_not_created_any_shifts_yet')}
                     showButton={((DEV || permission?.includes(permissionObj?.WEB_FOODIE_SHIFT_CREATE)))}
                     buttonId={'btn_s_link_create_shift'}
                     buttonUrl={routes.foodieShift.create}
                     buttonTrans={'ddd_new_shift'}
                     searchElement={searchElement}
                />
            )}
        </>
    );
};

export default Shifts;
